export const PROPERTYLEFT = 'propertyLeft';
export const PROPERTYRIGHT = 'propertyRight';

export const DISPLAYER_NAME_APPLICANT_EMAIL = 'mortgage.urla1.1a.email'

export const BORROWER_APPLICANT = 'borrower_applicant';
export const BORROWER_TYPE_OF_CREDIT = 'borrower_type_of_credit';
export const BORROWER_MARITAL = 'borrower_marital';
export const COBORROWER_MARITAL = 'coborrower_marital';

export const BORROWER_CONTACT_INFO = 'borrower_contact';
export const COBORROWER_CONTACT_INFO = 'coborrower_contact';

export const BORROWER_CURRENT_ADDRESS = 'borrower_current_address';
export const COBORROWER_CURRENT_ADDRESS = 'coborrower_current_address';

export const BORROWER_MAILING_ADDRESS = 'borrower_mailing_address';
export const COBORROWER_MAILING_ADDRESS = 'coborrower_mailing_address';


export const BORROWER_FORMAR_ADDRESS = 'borrower_formar_address';
export const COBORROWER_FORMAR_ADDRESS = 'coborrower_formar_address';


export const BORROWERLEFT = 'borrowerLeft';
export const BORROWERRIGHT = 'borrowerRight';

export const W2_EMPLOYMENT = 'w2Employment';

export const SELF_EMPLOYMENT = 'selfEmployment';

export const MILITARYLEFT = 'militaryLeft';
export const MILITARYRIGHT = 'militaryRight';
export const REALESTATE_ASSET = 'realEstateAsset';
export const REALESTATE_PROPERTY = 'realEstateProperty';
export const INVESTMENT = 'Investment';
export const INCOME = 'income';

export const ASSETS = 'Assets';

export const LIABILITIES = 'Liabilities';

export const DECLARATION = 'Declaration';


export const DISPLAYER_LOAN_APP = 'LoanNumber'
export const DISPLAYER_APPLICANT_INFO_DISPLAYER = 'ApplicantInfoDisplayer';
export const DISPLAYER_APPLICANT_INFO_BUILDER = 'ApplicantBuilderInfo';
export const DISPLAYER_APPLICANT_END_LOAN_INFO = 'ApplicantEndLoanInfo';
export const DISPLAYER_APPLICANT_CARD_INFO_DISPLAYER = 'ApplicantCardInfoDisplayer';
export const DISPLAYER_APPLICANT_CURRENT_ADDRESS = 'ApplicantCurrentAddress';
export const DISPLAYER_FORMER_ADDRESS_ON_POPUP = 'ApplicantFormerAddressOnPopup';
export const DISPLAYER_APPLICANT_MAILING_ADDRESS = 'ApplicantMailingAddress';
export const DISPLAYER_APPLICANT_MARITAL_STATUS = 'ApplicantMaritalStatus';
export const DISPLAYER_APPLICANT_CONTACT = 'ApplicantContactInfo';
export const DISPLAYER_TYPE_OF_CREDIT = 'ApplicantTypeOfCredit'
export const DISPLAYER_MORTGAGE_INFORMATION = 'MortgageInformation';
export const DISPLAYER_ALIMONY_INFORMATION = 'AlimonyInformation';
export const DISPLAYER_COLLATERAL_INFORMATION = 'CollateralInfo';
export const DISPLAYER_ADDITIONAL_COLLATERAL_INFORMATION = 'AdditionalCollateralInfo';
export const DISPLAYER_COLLATERAL_OWNER_INFORMATION = 'CollateralOwnerInfo';
export const DISPLAYER_FEES_AND_CHARGES = 'FeesAndCharges';
export const DISPLAYER_PERSONALLOAN_MARITAL_STATUS = 'PersonalLoanMaritalStatus';
export const DISPLAYER_PERSONALLOAN_CONTACT_INFO = 'PersonalLoanContactInfo';
export const DISPLAYER_CIP_INFO = 'CIPInfoDisplayer';
export const DISPLAYER_SECONDARY_CIP_INFO = 'CIPSecondaryInfoApplicantDisplayer';
export const DISPLAYER_BSA_QUESTIONNAIRE = 'BSAQuestionnaireDisplayer';

export const DISPLAYER_HOUSING_EXPENSE = 'HousingExpenseInfo';

export const DISPLAYER_MORE_COLLATORAL_INFO = 'MoreCollateralInfo';
export const DISPLAYER_MORE_COLLATORAL_TABLE_LIST = 'MoreCollateralTableList';
export const DISPLAYER_MORE_COLLATORAL_SECURITY_LIST = 'MoreCollateralSecurityList';
export const DISPLAYER_MORE_COLLATORAL_OWNERS_LIST = 'MoreCollateralOwnersList';
export const DISPLAYER_MORE_COLLATORAL_INSURANCE_LIST = 'MoreCollateralInsuranceList';

export const DISPLAYER_MILITARY_DISPLAYER = 'MilitaryDisplayer';
export const DISPLAYER_ID_INFO = 'IDInfoDisplayer';
export const DISPLAYER_SEC_ID_INFO = 'SecondaryIDInfoDisplayer';
export const DISPLAYER_HOUSING_INFO = 'HousingInfo';
export const DISPLAYER_MLA_INFO = 'ApplicantMLAInfo';
export const DISPLAYER_APPLICATION_INFO = 'ApplicationInfo';
export const DISPLAYER_MARITAL_STATUS_INFO = 'MartialStatus';
export const DISPLAYER_CONSTRUCTION_BUILDER_INFO = 'ConstructionBuilder'
export const DISPLAYER_END_LOAN_INFO = 'EndLoanInfo'


export const DISPLAYER_APPLICANT_LANGUAGES = 'ApplicantLanguages';
export const DISPLAYER_OTHER_INCOME_SOURCES = 'OtherIncomeSources';
export const DISPLAYER_OTHER_INCOMES_POPUP = 'OtherIncomesPopup';
export const DISPLAYER_ASSETS_DEPOSITORY = 'AssetsDepository'
export const DISPLAYER_ASSETS = 'Assets'
export const DISPLAYER_ASSETS_TOTAL = 'AssetsTotal'
export const DISPLAYER_ASSETS_FROM = 'AssetsFrom'
export const DISPLAYER_OTHER_ASSETS = 'OtherAssets'
export const DISPLAYER_TOTAL_OTHER_ASSETS = 'TotalOtherAssets';
export const DISPLAYER_OTHER_ASSETS_DEPOSITORY = 'OtherAssetsDepository'
export const DISPLAYER_OTHER_ASSETS_FROM = 'OtherAssetsFrom'
export const DISPLAYER_APPLICANT_FORMER_ADDRESS = 'ApplicantFormerAddress'
export const DISPLAYER_CURRENT_ADDRESS_FROM = 'CurrentAddressFrom'
export const DISPLAYER_CURRENT_ADDRESS_LANDLORD = 'CurrentAddressLandLord'
export const DISPLAYER_FORMER_ADDRESS_LANDLORD = 'FormerAddressLandlord'
export const DISPLAYER_FORMER_ADDRESS_FROM = 'FormerAddressFrom'
export const DISPLAYER_VOE_EMPLOYMENT = 'VOETableEmployment'
export const DISPLAYER_VOE_EMPLOYER_HISTORY = 'VOEEmployerHistory'
export const DISPLAYER_VOE_EMPLOYMENT_FROM = 'VOEEmploymentFrom'
export const DISPLAYER_VOE_NAME_AND_ADDRESS = 'VOENameAndAddressDisplayer'
export const DISPLAYER_VOE_EMPLOYER_GROSSINCOME = 'VOEEmployerGrossIncome'
export const DISPLAYER_VOE_EMPLOYER_INFORMATION = 'VOEEmployerInformation'
export const DISPLAYER_VOE_OWNERSHIP_SHARE = 'VOEOwnershipShare'
export const DISPLAYER_REALESTATE = 'RealEstate'
export const DISPLAYER_REALESTATE_ADDITIONAL = 'RealEstateAdditional'
export const DISPLAYER_VOM_TABLE_DISPLAYER = 'VOMTableDisplayer'
export const DISPLAYER_VOM_PROPERTY_INFO_LEFT = 'VOMPropertyInfoLeft'
export const DISPLAYER_VOM_PROPERTY_INFO_RIGHT = 'VOMPropertyInfoRight'
export const DISPLAYER_VOM_FROM = 'VOMFrom'
export const DISPLAYER_LIABILITIES = 'Liabilities'

export const DISPLAYER_LIABILITIES_ACCOUNT_INFO = 'LiabilitiesAccountInfo'
export const DISPLAYER_LIABILITIES_DEBT_INFORMATION = 'LiabilitiesDebtInformation'
export const DISPLAYER_LIABILITIES_PAYMENT_HISTORY = 'LiabilitiesPaymentHistory'
export const DISPLAYER_LIABILITIES_NAME_AND_ADDRESS = 'LiabilitiesNameAndAddress'
export const DISPLAYER_LIABILITIES_FROM = 'LiabilitiesFrom';
export const DISPLAYER_LIABILITIES_ABILITY_TO_REPAY = 'LiabilitiesAbilityToRepay';
export const DISPLAYER_TOTAL_MONTHLY_LIABILITIES = 'TotalMonthlyLiabilities';
export const DISPLAYER_TOTAL_LIABILITIES_BALANCE = 'TotalLiabilitiesBalance';
export const DISPLAYER_TOTAL_PAYOFF_LIABILITIES = 'TotalPayoffLiabilities';
export const DISPLAYER_TRANSFER_BALANCE_ASSET = 'TransferBalanceAsset'

export const DISPLAYER_OTHER_LIABILITIES = 'OtherLiabilities'
export const DISPLAYER_OTHER_LIABILITIES_ACCOUNTINFO = 'OtherLiabilitiesAccountInfo'
export const DISPLAYER_OTHER_LIABILITIES_NAMEANDADDRESS = 'OtherLiabilitiesNameAndAddress'
export const DISPLAYER_OTHER_LIABILITIES_FROM = 'OtherLiabilitiesFrom'
export const DISPLAYER_TOTAL_OTHER_LIABILITIES = 'TotalOtherLiabilities';
export const DISPLAYER_APPLICANT_GIFTSANDGRANTS = 'ApplicantGiftsAndGrants';
export const DISPLAYER_GIFTSANDGRANTS_TOTAL = 'GiftsAndGrantsTotal';
export const DISPLAYER_VOGG_FROM = 'VOGGFrom'
export const DISPLAYER_VOGG_NAME_AND_ADDRESS = 'VOGGNameAndAddress'
export const DISPLAYER_VOGG_TABLE_DISPLAYER = 'VOGGTableDisplayer'
export const DISPLAYER_OTHER_MORTGAGE_LOANS = 'OtherMortgageLoans'
export const DISPLAYER_OTHERLOANS_POPUP = 'OtherLoansPopup'
export const DISPLAYER_APPLICANT_DECLARATION = 'ApplicantDeclaration'
export const DISPLAYER_APPLICANT_DEMOGRAPHIC = 'ApplicantDemographic'
export const DISPLAYER_CURRENT_EMPLOYMENT = 'CurrentEmployment'
export const DISPLAYER_ADDITIONAL_EMPLOYMENT = 'AdditionalEmployment'
export const DISPLAYER_PREVIOUS_EMPLOYMENT = 'PreviousEmployment'
export const DISPLAYER_APPLICANT_DEMOGRAPHIC_ETHNICITY = 'EthnicityDisplayer'
export const DISPLAYER_APPLICANT_DEMOGRAPHIC_RACE = 'RaceDisplayer'
export const DISPLAYER_APPLICANT_DEMOGRAPHIC_GENDER = 'GenderDisplayer'
export const DISPLAYER_MITICATING_FACTOR = 'MiticatingFactorInfo';
export const DISPLAYER_SECURITY_INFO = 'SecurityInfo';
export const DISPLAYER_GRANTORS_INFO = 'GrantorInfo';
export const DISPLAYER_FLOOD_INSURANCE = 'FloodInsurance';
export const DISPLAYER_COLLATERAL_INSURANCE_INFO = 'CollaterlInsurance';
export const DISPLAYER_ACH_INFO = 'ACHInfo';
export const DISPLAYER_DISBURSEMENT_INFO = 'DisbursementInfo';
export const DISPLAYER_INSTALLMENT_LOAN_INFO = 'CollateralInstallmentLoanInfo';
export const DISPLAYER_COLLATERAL_REAL_ESTATE_INFO = 'CollateralRealEstateInfo';
export const DISPLAYER_OVERRIDE_INFO = 'OverrideInfo';


export const DISPLAYER_PROPERTY_LOAN_ADDRESS = 'PropertyLoanAddress'
export const DISPLAYER_PROPERTY_LOAN_AMOUNT = 'PropertyLoanAmount'
export const DISPLAYER_PROPERTY_LOAN_TYPE = 'PropertyLoanType'
export const DISPLAYER_PROPERTY_LOT_AND_LAND = 'PropertyLotAndLand'
export const DISPLAYER_PROPERTY_LOAN_PURPOSE = 'PropertyLoanPurpose'
export const DISPLAYER_PROPERTY_CONSTRUCTION_LOAN = 'PropertyConstructionLoans'
export const DISPLAYER_MIXED_USE_AND_MANUFACTURED = 'MixedUseAndManufactured'
export const DISPLAYER_PROPERTY_RENTAL_INCOME = 'PropertyRentalIncome';
export const DISPLAYER_COLLATERAL_OFFERED = "CollateralOffered"
export const DISPLAYER_COLLATERAL_OFFERED_UNSECURED = "CollateralOfferedUnsecured"
export const DISPLAYER_COLLATERAL_OFFERED_ORIGINATOR_SECURED = "CollateralOfferedWithOrginatorSecured"
export const DISPLAYER_INSTITUTIONAL = 'InstitutionDisplayer';
export const DISPLAYER_DEMOGRAPHIC_PROVIDER = 'DemographicProvidedInfo'
export const DISPLAYER_SECURITY_INFORMATION = 'SecurityInformation';
export const DISPLAYER_OTHER_INCOME_SOURCES_CARDS = 'OtherIncomeSourceCards'
export const DISPLAYER_CURRENT_EMPLOYMENT_PERSONALLOAN = 'PersonalLoanCurrentEmployment';
export const DISPLAYER_PREVIOUS_EMPLOYMENT_PERSONALLOAN = 'PersonalLoanPreviousEmployment';


export const SECTION_APPLICATION_INFO = 'Application Information';
export const SECTION_INSTALLMENT_LOAN_TRANSACTION = 'Installment Loan Transaction';
export const SECTION_OVERRIDE_INFO = 'Override';
export const SECTION_PERSONAL_INFO = 'Personal Information';
export const SECTION_ASSET = 'Assets';
export const SECTION_CURRENT_ADDRESS = 'Current Address';
export const SECTION_CIP_INFORMATION = 'CIP Information';
export const SECTION_CIP_SECONDARY_INFORMATION = 'CIP Information (Secondary)';
export const SECTION_FEES_AND_CHARGES = 'Fees & Charges';
export const SECTION_ACH_INFO = 'ACH Payment Information';
export const SECTION_DISBURSEMENT = 'Disbursement Information';
export const SECTION_COLLATERAL_INSURANCE = 'Collateral Insurance';
export const DOES_NOT_APPLY = 'Does not apply';
export const MAX_DISPLAYER_COUNT = 10;
export const MIN_DISPLAYER_COUNT = 1;


// Does not apply displayers
export const DISPLAYER_DOESNOT_APPLY_REALESTATE = 'DoesNotApplyOnRealEstates';
export const DISPLAYER_DOESNOT_APPLY_LIABILITIES = 'DoesNotApplyOnLiabilities';
export const DISPLAYER_DOESNOT_APPLY_OTHER_LIABILITIES = 'DoesNotApplyOnOtherLiabilities';
export const DISPLAYER_DOESNOT_APPLY_OTHER_ASSETS = 'DoesNotApplyOnOtherAssets';
export const DISPLAYER_DOESNOT_APPLY_CURRENT_EMPLOYMENT = 'DoesNotApplyOnCurrentEmployments'
 export const DISPLAYER_DOESNOT_APPLY_PREVIOUS_EMPLOYMENT = 'DoesNotApplyOnPreviousEmployments'
 export const DISPLAYER_DOESNOT_APPLY_ADDITIONAL_EMPLOYMENT = 'DoesNotApplyOnAdditionalEmployments'
 export const DISPLAYER_DOESNOT_APPLY_OTHER_INCOMES = 'DoesNotApplyOnOtherIncomes'
 export const DISPLAYER_DOESNOT_APPLY_GIFTS_AND_GRANTS = 'DoesNotApplyOnGiftsAndGrants'
 export const DISPLAYER_DOESNOT_APPLY_BALANCE_TRANSFER = 'DoesNotApplyOnBalanceTransfer'
